import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const result = await login(username, password);

    if (result.success) {
      navigate(from, { replace: true });
    } else {
      setError(result.message);
    }
    
    setLoading(false);
  };

  return (
    <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'radial-gradient(ellipse at 20% 50%, rgba(212,175,55,0.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(212,175,55,0.04) 0%, transparent 50%), #0a0a0a',
        padding: '1rem', position: 'relative', overflow: 'hidden'
    }}>
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, background: 'radial-gradient(ellipse 600px 400px at 50% 40%, rgba(212,175,55,0.05), transparent)' }} />

      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>🕉️</div>
          <h1 style={{ fontSize: '2rem', fontWeight: 900, letterSpacing: '0.15em', background: 'linear-gradient(135deg, #E8B84B 0%, #FFD26E 50%, #B8923A 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '0.25rem' }}>Ananda Marga</h1>
          <p style={{ color: '#666', fontSize: '0.75rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>Stream Admin Panel</p>
        </div>

        <div className="glass-card" style={{ padding: '2rem', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(212,175,55,0.1)', borderRadius: '1rem', backdropFilter: 'blur(10px)' }}>
          <h2 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#fff', marginBottom: '0.25rem' }}>Sign In</h2>
          <p style={{ color: '#666', fontSize: '0.8rem', marginBottom: '1.75rem' }}>Enter your credentials to access the panel</p>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.4rem', color: '#E8B84B', fontSize: '0.85rem' }}>Username</label>
              <input type="text" className="form-input" placeholder="Enter username" value={username} onChange={e => setUsername(e.target.value)} required disabled={loading}
                style={{ width: '100%', padding: '0.75rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '0.5rem', color: '#fff' }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.4rem', color: '#E8B84B', fontSize: '0.85rem' }}>Password</label>
              <div style={{ position: 'relative' }}>
                <input type={showPassword ? 'text' : 'password'} className="form-input" placeholder="Enter password" value={password} onChange={e => setPassword(e.target.value)} required disabled={loading}
                  style={{ width: '100%', padding: '0.75rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '0.5rem', color: '#fff', paddingRight: '2.75rem' }}
                />
                <button type="button" onClick={() => setShowPassword(v => !v)} style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#666' }}>
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            {error && (
              <div style={{ background: 'rgba(248,68,68,0.1)', border: '1px solid rgba(248,68,68,0.3)', borderRadius: '0.5rem', padding: '0.75rem 1rem', color: '#f87171', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span>⚠ {error}</span>
              </div>
            )}

            <button type="submit" disabled={loading} style={{ marginTop: '0.25rem', width: '100%', padding: '0.75rem', background: 'linear-gradient(90deg, #E8B84B, #B8923A)', border: 'none', borderRadius: '0.5rem', color: '#000', fontWeight: 'bold', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Signing in...' : '→ Sign In'}
            </button>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
                {/* Centre onboarding — for verified religious institutions */}
                <a href="/centre-register" style={{ color: '#FF9933', fontSize: '0.8rem', textDecoration: 'none', transition: 'color 0.2s', display: 'flex', alignItems: 'center', gap: '0.3rem' }} onMouseOver={(e) => e.target.style.color = '#ffb347'} onMouseOut={(e) => e.target.style.color = '#FF9933'}>
                  Register a Centre
                </a>
                {/* Acarya registration */}
                <a href="/acarya-register" style={{ color: '#E56B2E', fontSize: '0.8rem', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={(e) => e.target.style.color = '#ff8243'} onMouseOut={(e) => e.target.style.color = '#E56B2E'}>
                  Apply as Acarya
                </a>
                {/* Vendor registration — for product/service sellers */}
                <a href="/vendor-register" style={{ color: '#E8B84B', fontSize: '0.8rem', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={(e) => e.target.style.color = '#FFD26E'} onMouseOut={(e) => e.target.style.color = '#E8B84B'}>
                  Apply as Vendor
                </a>
              </div>
              <div style={{ textAlign: 'right' }}>
                <a href="/forgot-password" style={{ color: '#666', fontSize: '0.8rem', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={(e) => e.target.style.color = '#E8B84B'} onMouseOut={(e) => e.target.style.color = '#666'}>
                  Forgot Password?
                </a>
              </div>
            </div>
          </form>
        </div>
        <p style={{ textAlign: 'center', marginTop: '1.5rem', color: '#444', fontSize: '0.7rem' }}>Ananda Marga © 2026 — Restricted Access</p>
      </div>
    </div>
  );
};

export default Login;